export const CC_SHORT = [
    "Bank Select", // 0
    "Modulation Wheel", // 1
    "Breath Controller", // 2
    "Undefined", // 3
    "Foot Controller", // 4
    "Portamento Time", // 5
    "Data Entry MSB", // 6
    "Channel Volume", // 7
    "Balance", // 8
    "Undefined", // 9
    "Pan", // 10
    "Expression Controller", // 11
    "Effect Control 1", // 12
    "Effect Control 2", // 13
    "Undefined", // 14
    "Undefined", // 15
    "General Purpose Ctrl 1", // 16
    "General Purpose Ctrl 2", //
    "General Purpose Ctrl 3", //
    "General Purpose Ctrl 4", //
    "Undefined", // 20
    "Undefined", // 
    "Undefined", // 
    "Undefined", // 
    "Undefined", // 
    "Undefined", // 
    "Undefined", // 
    "Undefined", // 
    "Undefined", // 
    "Undefined", // 
    "Undefined", // 
    "Undefined", // 
    "LSB for CC 0", // 32
    "LSB for CC 1", // 
    "LSB for CC 2", // 
    "LSB for CC 3", // 
    "LSB for CC 4", // 
    "LSB for CC 5", // 
    "LSB for CC 6", // 
    "LSB for CC 7", // 
    "LSB for CC 8", // 40
    "LSB for CC 9", // 
    "LSB for CC 10", // 
    "LSB for CC 11", // 
    "LSB for CC 12", // 
    "LSB for CC 13", // 
    "LSB for CC 14", // 46
    "LSB for CC 15", // 
    "LSB for CC 16", // 48
    "LSB for CC 17", // 
    "LSB for CC 18", // 
    "LSB for CC 19", // 
    "LSB for CC 20", // 52
    "LSB for CC 21", // 
    "LSB for CC 22", // 
    "LSB for CC 23", // 
    "LSB for CC 24", // 
    "LSB for CC 25", // 
    "LSB for CC 26", // 
    "LSB for CC 27", // 
    "LSB for CC 28", // 60
    "LSB for CC 29", // 
    "LSB for CC 30", // 
    "LSB for CC 31", // 
    "Damper Pedal on/off", // 64
    "Portamento On/Off",
    "Sostenuto On/Off",
    "Soft Pedal On/Off",
    "Legato Footswitch",
    "Hold 2", // 69
    "Sound Controller 1", // 70
    "Sound Controller 2", //
    "Sound Controller 3", //
    "Sound Controller 4", //
    "Sound Controller 5", //
    "Sound Controller 6", //
    "Sound Controller 7", //
    "Sound Controller 8", //
    "Sound Controller 9", //
    "Sound Controller 10", //
    "General Purpose Ctrl 5", // 80
    "General Purpose Ctrl 6", //
    "General Purpose Ctrl 7", //
    "General Purpose Ctrl 8", //
    "Portamento Control", // 84
    "Undefined",
    "Undefined",
    "Undefined",
    "High Res Velocity Prefix", // 88
    "Undefined",
    "Undefined",
    "Effects 1 Depth", // 91
    "Effects 2 Depth", //
    "Effects 3 Depth",
    "Effects 4 Depth", //
    "Effects 5 Depth", //
    "Data Increment", // 96
    "Data Decrement",
    "NRPN - LSB", //
    "NRPN - MSB", //
    "RPN - LSB*", // 100
    "RPN - MSB*", //
    "Undefined", // 102
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined", // 110
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined",
    "All Sound Off", // 120
    "Reset All Ctrls",
    "Local Control On/Off",
    "All Notes Off", // 123
    "Omni Mode Off",
    "Omni Mode On",
    "Mono Mode On", // 126
    "Poly Mode On" // 127
    // "[Channel Mode Message] All Sound Off", // 120
    // "[Channel Mode Message] Reset All Controllers",
    // "[Channel Mode Message] Local Control On/Off",
    // "[Channel Mode Message] All Notes Off", // 123
    // "[Channel Mode Message] Omni Mode Off (+ all notes off)",
    // "[Channel Mode Message] Omni Mode On (+ all notes off)",
    // "[Channel Mode Message] Mono Mode On (+ poly off, + all notes off)", // 126
    // "[Channel Mode Message] Poly Mode On (+ mono off, +all notes off)" // 127
];
export const CC = [
    "Bank Select", // 0
    "Modulation Wheel or Lever", // 1
    "Breath Controller", // 2
    "Undefined", // 3
    "Foot Controller", // 4
    "Portamento Time", // 5
    "Data Entry MSB", // 6
    "Channel Volume (formerly Main Volume)", // 7
    "Balance", // 8
    "Undefined", // 9
    "Pan", // 10
    "Expression Controller", // 11
    "Effect Control 1", // 12
    "Effect Control 2", // 13
    "Undefined", // 14
    "Undefined", // 15
    "General Purpose Controller 1", // 16
    "General Purpose Controller 2", // 
    "General Purpose Controller 3", // 
    "General Purpose Controller 4", // 
    "Undefined", // 20
    "Undefined", // 
    "Undefined", // 
    "Undefined", // 
    "Undefined", // 
    "Undefined", // 
    "Undefined", // 
    "Undefined", // 
    "Undefined", // 
    "Undefined", // 
    "Undefined", // 
    "Undefined", // 
    "LSB for Control 0 (Bank Select)", // 32
    "LSB for Control 1 (Modulation Wheel or Lever)", // 
    "LSB for Control 2 (Breath Controller)", // 
    "LSB for Control 3 (Undefined)", // 
    "LSB for Control 4 (Foot Controller)", // 
    "LSB for Control 5 (Portamento Time)", // 
    "LSB for Control 6 (Data Entry)", // 
    "LSB for Control 7 (Channel Volume, formerly Main Volume)", // 
    "LSB for Control 8 (Balance)", // 40
    "LSB for Control 9 (Undefined)", // 
    "LSB for Control 10 (Pan)", // 
    "LSB for Control 11 (Expression Controller)", // 
    "LSB for Control 12 (Effect control 1)", // 
    "LSB for Control 13 (Effect control 2)", // 
    "LSB for Control 14 (Undefined)", // 46
    "LSB for Control 15 (Undefined)", // 
    "LSB for Control 16 (General Purpose Controller 1)", // 48
    "LSB for Control 17 (General Purpose Controller 2)", // 
    "LSB for Control 18 (General Purpose Controller 3)", // 
    "LSB for Control 19 (General Purpose Controller 4)", // 
    "LSB for Control 20 (Undefined)", // 52
    "LSB for Control 21 (Undefined)", // 
    "LSB for Control 22 (Undefined)", // 
    "LSB for Control 23 (Undefined)", // 
    "LSB for Control 24 (Undefined)", // 
    "LSB for Control 25 (Undefined)", // 
    "LSB for Control 26 (Undefined)", // 
    "LSB for Control 27 (Undefined)", // 
    "LSB for Control 28 (Undefined)", // 60
    "LSB for Control 29 (Undefined)", // 
    "LSB for Control 30 (Undefined)", // 
    "LSB for Control 31 (Undefined)", // 
    "Damper Pedal on/off (Sustain)", // 64
    "Portamento On/Off",
    "Sostenuto On/Off",
    "Soft Pedal On/Off",
    "Legato Footswitch",
    "Hold 2", // 69
    "Sound Controller 1 (default: Sound Variation)", // 70
    "Sound Controller 2 (default: Timbre/Harmonic Intens.)", // 
    "Sound Controller 3 (default: Release Time)", // 
    "Sound Controller 4 (default: Attack Time)", // 
    "Sound Controller 5 (default: Brightness)", // 
    "Sound Controller 6 (default: Decay Time)", //
    "Sound Controller 7 (default: Vibrato Rate)", //
    "Sound Controller 8 (default: Vibrato Depth)", //
    "Sound Controller 9 (default: Vibrato Delay)", //
    "Sound Controller 10 (default undefined)", //
    "General Purpose Controller 5", // 80
    "General Purpose Controller 6", // 
    "General Purpose Controller 7", // 
    "General Purpose Controller 8", // 
    "Portamento Control", // 84
    "Undefined",
    "Undefined",
    "Undefined",
    "High Resolution Velocity Prefix", // 88
    "Undefined",
    "Undefined",
    "Effects 1 Depth", // 91
    "Effects 2 Depth (formerly Tremolo Depth)", //
    "Effects 3 Depth",
    "Effects 4 Depth (formerly Celeste [Detune] Depth)", //
    "Effects 5 Depth (formerly Phaser Depth)", // 
    "Data Increment (Data Entry +1)", // 96
    "Data Decrement (Data Entry -1)",
    "Non-Registered Parameter Number (NRPN) - LSB", // 
    "Non-Registered Parameter Number (NRPN) - MSB", // 
    "Registered Parameter Number (RPN) - LSB*", // 100
    "Registered Parameter Number (RPN) - MSB*", // 
    "Undefined", // 102
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined", // 110
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined",
    "Undefined",
    "All Sound Off", // 120
    "Reset All Controllers",
    "Local Control On/Off",
    "All Notes Off", // 123
    "Omni Mode Off (+ all notes off)",
    "Omni Mode On (+ all notes off)",
    "Mono Mode On (+ poly off, + all notes off)", // 126
    "Poly Mode On (+ mono off, +all notes off)" // 127
    // "[Channel Mode Message] All Sound Off", // 120
    // "[Channel Mode Message] Reset All Controllers",
    // "[Channel Mode Message] Local Control On/Off",
    // "[Channel Mode Message] All Notes Off", // 123
    // "[Channel Mode Message] Omni Mode Off (+ all notes off)",
    // "[Channel Mode Message] Omni Mode On (+ all notes off)",
    // "[Channel Mode Message] Mono Mode On (+ poly off, + all notes off)", // 126
    // "[Channel Mode Message] Poly Mode On (+ mono off, +all notes off)" // 127
];
